import ToolTip from "components/design/toolTip";
import { openDownloadUrl } from "util/openDownloadUrl";
import { Button } from "components/DesignSystem/Button/Button";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { DownloadIcon } from "components/icons/Download";
import { Files } from "components/icons/Files";
import { useLazyGetPreviewUrlQuery } from "store/apis/previewUrl";

const FilingDraftCardBodyRow = ({
  downloadFile,
  children,
  showOrangeDot,
  isLoading,
}: {
  downloadFile: () => void;
  showOrangeDot?: boolean;
  children: React.ReactNode;
  isLoading: boolean;
}) => {
  return (
    <div className="t-flex t-items-center t-justify-between">
      <div className="t-flex t-gap-3 t-items-center">
        <div className="t-h-6 t-w-6 t-rounded-full t-border t-border-solid t-border-neutral-0 t-flex t-items-center t-justify-center t-relative">
          <div className="t-text-text-30 -t-mt-0.5">
            <Files />
          </div>
          {showOrangeDot && (
            <div className="t-min-w-1.5 t-min-h-1.5 t-max-h-1.5 t-max-w-1.5 t-rounded-full t-bottom-0 t-right-0 t-absolute t-bg-orange" />
          )}
        </div>
        {children}
      </div>
      <Button
        size="small"
        customType="ghost_icon"
        onClick={downloadFile}
        isLoading={isLoading}
      >
        <span className="t-text-text-60">
          <DownloadIcon color="currentColor" size={24} />
        </span>
      </Button>
    </div>
  );
};

export const FilingDraftCardBody = ({
  approveStatus,
  groupId,
  fileId,
  rejectionReason,
}: {
  approveStatus: boolean | null;
  groupId: string;
  fileId: string;
  rejectionReason: string;
}) => {
  const [getPreviewUrl, { isLoading }] = useLazyGetPreviewUrlQuery();

  const downloadFile = async () => {
    try {
      const { download_url } = await getPreviewUrl({
        groupId,
        fileId,
      }).unwrap();
      openDownloadUrl(download_url);
    } catch (error) {}
  };

  if (approveStatus)
    return (
      <FilingDraftCardBodyRow downloadFile={downloadFile} isLoading={isLoading}>
        <div>
          <div className="t-text-caption t-text-text-30">Review complete</div>
          <Tag tagType="green" size="small" rounded icon={false}>
            Draft approved
          </Tag>
        </div>
      </FilingDraftCardBodyRow>
    );

  if (approveStatus === false) {
    return (
      <>
        <FilingDraftCardBodyRow
          downloadFile={downloadFile}
          isLoading={isLoading}
        >
          <div>
            <div className="t-text-caption t-text-text-30">Review complete</div>
            <Tag tagType="red" size="small" rounded icon={false}>
              Draft rejected
            </Tag>
          </div>
        </FilingDraftCardBodyRow>
        <div className="t-p-2 t-rounded t-bg-surface-lighter-grey t-space-y-2 t-border t-border-solid t-border-surface-grey">
          <div className="t-text-body-sm t-text-text-60">Reason</div>
          <ToolTip text={rejectionReason}>
            <div className="t-line-clamp-5 t-text-body-sm t-text-text-30">
              {rejectionReason}
            </div>
          </ToolTip>
        </div>
      </>
    );
  }

  return (
    <FilingDraftCardBodyRow
      downloadFile={downloadFile}
      showOrangeDot
      isLoading={isLoading}
    >
      <div className="t-text-subtext t-text-text-60">Review pending</div>
    </FilingDraftCardBodyRow>
  );
};
